var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponent451(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 306.93,
    height: 306.93,
    viewBox: "0 0 306.93 306.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#71c9f0;opacity:0.78;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H206.93a100,100,0,0,1,100,100V306.93a0,0,0,0,1,0,0H100a100,100,0,0,1-100-100V0A0,0,0,0,1,0,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1341.93 -4384.073)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1509.8,4617.71v4.1a10.29,10.29,0,0,1-10.26,10.26h0a10.29,10.29,0,0,1-10.26-10.26v-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1468.76,4572.4v24.286a6.142,6.142,0,0,0,1.734,4.285c3.088,3.191,10.046,9.593,18.786,12.713v-.074h20.52v.074c8.739-3.12,15.7-9.522,18.785-12.713a6.142,6.142,0,0,0,1.734-4.285V4572.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1518.06,4482.325l-35.541,20.519a10.289,10.289,0,0,1-14.015-3.755h0a10.29,10.29,0,0,1,3.755-14.015l35.541-20.52a10.29,10.29,0,0,1,14.015,3.756h0A10.289,10.289,0,0,1,1518.06,4482.325Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1542.406,4515.614a10.291,10.291,0,0,0-14.015-3.756l-57.847,33.441a10.257,10.257,0,0,0-4.195,13.034,5.211,5.211,0,0,0,.44.981l5.183,8.978h23.694l-5.977-10.353,48.962-28.31A10.289,10.289,0,0,0,1542.406,4515.614Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1532.236,4549.12l-4.513-7.736-17.77,10.259,1.566,2.633-8.092,14.016h23.694l5.128-8.882a10.259,10.259,0,0,0,.224-9.793A5.158,5.158,0,0,0,1532.236,4549.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1502.568,4456.118a3.078,3.078,0,0,1-3.078-3.078v-23.084a3.078,3.078,0,1,1,6.155,0v23.084A3.078,3.078,0,0,1,1502.568,4456.118Zm-27.918,7.479a3.077,3.077,0,0,0,1.126-4.2l-11.542-19.991a3.078,3.078,0,0,0-5.331,3.078l11.543,19.991a3.073,3.073,0,0,0,4.2,1.126Zm-20.438,20.438a3.076,3.076,0,0,0-1.126-4.2l-19.992-11.543a3.078,3.078,0,1,0-3.078,5.331l19.992,11.542a3.073,3.073,0,0,0,4.2-1.126Zm100.913,1.126,19.992-11.542a3.078,3.078,0,0,0-3.078-5.331l-19.992,11.543a3.077,3.077,0,1,0,3.078,5.33Zm-20.438-22.69,11.543-19.991a3.078,3.078,0,0,0-5.331-3.078l-11.542,19.991a3.077,3.077,0,1,0,5.33,3.078Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1539.021,4499.316l-63.81,36.84a10.291,10.291,0,0,1-14.016-3.755h0a10.291,10.291,0,0,1,3.756-14.016l63.81-36.84a10.291,10.291,0,0,1,14.015,3.755h0A10.29,10.29,0,0,1,1539.021,4499.316Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent451);
export default __webpack_public_path__ + "static/media/Component45–1.7562cf46409dde1bb275718dc9bd9ee4.svg";
export { ForwardRef as ReactComponent };